import React, {Component} from 'react';
import '../css/Footer.css';
import Vas from '../Vas';
import revisionNumber from '../RevisionNumber.js';

// eslint-disable-next-line react/prefer-stateless-function
class Footer extends Component
{
    render(){

        let mail = "mailto:" + Vas.CopyrightMail;
        return(
        <div className={"footer"}>
            <a className={"footerMail"} href={mail}>
                <div className={"footMail"}>{Vas.CopyrightMail}</div>
            </a> {"|"} 
            <div className={"footPhone"} >{Vas.CopyrightPhone} </div>
            <div className={"footerPhone"}>{Vas.Resources.Labels["LocalRate"]}<div id={"RevisionNumber"} style={{ fontSize: '8px', float: 'right', width: '70px'}}>2.{revisionNumber}</div></div>
        </div>
        );
    }
}
export default Footer;